import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { AdditionalDocument } from 'src/app/api.service';

@Injectable()
export class AdditionalDocumentControlFactory {
  constructor(private fb: UntypedFormBuilder) {}

  createAdditionalDocumentControl(value: AdditionalDocument): UntypedFormGroup {
    const control = this.createGroup();
    control.setValue(value);
    return control;
  }

  createMany(count: number): UntypedFormGroup[] {
    const output = [];

    for (let i = 0; i < count; i++) {
      output.push(this.createGroup());
    }

    return output;
  }

  private createGroup() {
    return this.fb.group({
      id: [],
      included: [],
      dateUploaded: [],
      fileId: [],
      fileName: [],
    });
  }
}
